export default {
  instruction: {
    header: 'Consignes',
    rate: 'Notifications "Évaluer les consignes"',
    rateFrequency: 'La fréquence',
    duration: 'Intervalle de temps',
  },
};
